// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1665":"ed684291","2140":"e01d85cb","5710":"ed684291"}[chunkId] + ".chunk.css";
};